export default class JqueryService {
  constructor() {
    this.jquery = $;
  }

  getJquery() {
    return this.jquery;
  }

  /**
   * Método que faz animação de um elemento
   * @param {*} event // Evento que será executado
   * @param {*} element // Elemento que será animado
   * @param {*} props // Propriedades do contador
   * 
   */
  dataCounter(event, element, props) {
    this.jquery(window).on(event, element, function () {
      var scrollTop = 0;
      var targetOffset = element.offset().top - window.innerHeight;
      if (scrollTop == 0 && $(window).scrollTop() > targetOffset) {
        // number count for stats, using jQuery animate
        $('[data-count]').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({ countNum: $this.text() }).animate({
            countNum: countTo
          }, {
            duration: props.duration,
            easing: props.easing,
            step: function () {
              $this.text(Math.floor(this.countNum));
            },
            complete: function () {
              $this.text(this.countNum);
            }
          });
        });
        scrollTop = 1;
      }
    });
  }

}